module.exports = __webpack_public_path__ + "img/racecourse-mauritius-turf-1400.ae706bb8.svg";